module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "py-0": ""
    },
    on: {
      "touchstart": _vm.touchStart,
      "touchend": _vm.touchEnd
    }
  }, [(_vm.onMobileStrict) ? _c('div', {
    staticClass: "mobile-top _logo"
  }, [_c('div', {
    staticClass: "logo-img-wrapper",
    class: {
      'allChildrenCenter': _vm.activeView == 'landingView'
    }
  }, [_c('img', {
    staticClass: "cursor-pointer logo-img",
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "130",
      "alt": "Yousound Logo"
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "switch-tab",
    class: {
      'landingView': _vm.activeView == 'landingView',
      'learnMoreView': _vm.activeView == 'learnMoreView'
    }
  }, [_c('span', {
    staticClass: "_icon",
    class: {
      _filled: _vm.activeView === 'landingView'
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "_icon",
    class: {
      _filled: _vm.activeView === 'learnMoreView'
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'learnMoreView'
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "full-authTabs-wrapper": "",
      "justify-center": "",
      "row": ""
    }
  }, [(_vm.activeView != 'loginView' && _vm.activeView != 'signUpView') ? _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onMobileStrict || (_vm.onMobileStrict && _vm.activeView === 'landingView')),
      expression: "!onMobileStrict || (onMobileStrict && activeView === 'landingView')"
    }],
    class: {
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "flex-column": "",
      "xs12": "",
      "sm6": "",
      "allChildrenCenter": "",
      "full-authTabs-twin": "",
      "full-authTabs-left": "",
      "text-center": ""
    }
  }, [(!_vm.onMobileStrict) ? _c('div', {
    staticClass: "_logo"
  }, [_c('img', {
    staticClass: "cursor-pointer logo-img",
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "130",
      "alt": "Yousound Logo"
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "_banner"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/banner.gif'),
      "width": "70%",
      "alt": "artist with sound machine"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "intro-title mt-5"
  }, [_vm._v("The best place for "), (_vm.onMobileStrict) ? _c('br') : _vm._e(), _vm._v(" music lovers.")]), _vm._v(" "), (_vm.showAuthCTA && !_vm.onMobileStrict) ? _c('div', {
    staticClass: "dflex auth-btns mt-3"
  }, [(_vm.showSignupBtn) ? _c('v-btn', {
    attrs: {
      "ripple": false,
      "depressed": "",
      "dark": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'signUpView'
      }
    }
  }, [_vm._v("\n          Signup\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showLoginBtn) ? _c('v-btn', {
    attrs: {
      "ripple": false,
      "depressed": "",
      "round": "",
      "outline": ""
    },
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("\n          Login\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showAuthCTA) ? _c('h2', {
    staticClass: "learn-more",
    on: {
      "click": _vm.handleLearnMore
    }
  }, [_vm._v("\n        Learn More\n      ")]) : _vm._e(), _vm._v(" "), (_vm.onMobileStrict) ? _c('div', {
    staticClass: "app-download"
  }, [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "40%",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "40%",
      "alt": "android app store icon"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.onMobileStrict) ? _c('app-footer') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onMobileStrict || (_vm.onMobileStrict && _vm.activeView === 'learnMoreView')),
      expression: "!onMobileStrict || (onMobileStrict && activeView === 'learnMoreView')"
    }],
    class: {
      auth__view: _vm.toDisplayGrid,
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "xs12": "",
      "sm6": "",
      "full-authTabs-twin": "",
      "full-authTabs-right": ""
    }
  }, [(_vm.activeView === 'landingView') ? _c('div', {
    staticClass: "landing-view"
  }, [_c('div', {
    staticClass: "trending-top dflex align-center justify-space-between"
  }, [_c('h2', {
    staticClass: "trending-title"
  }, [_vm._v("Trending")]), _vm._v(" "), _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(tab.title) + "\n                  ")])])
  }), _vm._v(" "), _c('v-spacer')], 2)])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'music') ? _c('trending-music', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs3 px-1 mb-1",
      "hideTrackLength": "",
      "noMeta": "",
      "hideCta": "",
      "showHoverTrackInfo": "",
      "title": "",
      "playButton2": "",
      "playButton2IconHasWhiteBG": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'videos') ? _c('trending-video', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs4 px-1",
      "title": "",
      "coverOnly": "",
      "showFullOverlay": "",
      "hoverOverlay": "",
      "hideCta": "",
      "coverRadius": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'merch') ? _c('trending-product', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs3 px-1 mb-1",
      "altMeta": false,
      "hideCta": "",
      "title": "",
      "showFullOverlay": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'signUpView') ? _c('div', {
    staticClass: "signup-view"
  }, [_c('div', {
    staticClass: "sign-up_logo",
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "150"
    }
  })]), _vm._v(" "), _c('Onboarding')], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'loginView') ? _c('div', {
    staticClass: "login-view"
  }, [_c('div', {
    staticClass: "sign-up_logo",
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "150"
    }
  })]), _vm._v(" "), (_vm.loginAuth === 'login') ? _c('div', {
    staticClass: "login-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center my-4"
  }, [_c('h2', [_vm._v("Hello,")]), _vm._v(" "), _c('h2', [_vm._v("welcome back!")])]), _vm._v(" "), _c('login-input', {
    attrs: {
      "showForgotPassword": _vm.showForgotPassword
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginAuth === 'forgotPassword') ? _c('div', {
    staticClass: "forgot-password-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center"
  }, [_c('h2', [_vm._v("Forgot Password")])]), _vm._v(" "), _c('forgot-password-input', {
    attrs: {
      "showLogin": _vm.showLogin
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeView === 'learnMoreView') ? _c('div', {
    staticClass: "learn-more-view",
    style: ({
      'width': _vm.onMobileStrict ? '97%' : null
    })
  }, [_c('learn-more')], 1) : _vm._e()])], 1), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81f3b27e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/landing1.vue
// module id = 1802
// module chunks = 180